import React from 'react';
import MasterPage from 'components/MasterPage';
import { Row, Container, Card, Tabs, Tab } from 'react-bootstrap';
import HubspotForm from 'react-hubspot-form'
import { WidgetsOutlined, ArrowBackIos } from '@material-ui/icons';
import { Link } from 'react-router-dom';

import './style.css';

export default function NewQuote() {

  const getTamanho = (tamanho)=>{
    return window.innerWidth<=tamanho;
  }

  return (
    <Container fluid>
      <Row className="mt-1">
        <Link to="/master-agent/my-quotes" className="link-back">
          <ArrowBackIos className="icon-title icon-back" />
          <h6 className="font-13 mt-3">Voltar</h6>
        </Link>
      </Row>
      <Row className="mt-1">
        <WidgetsOutlined className="icon-title col-auto p-0" />
        <h5 className="title-dashboard col-10 p-0">Pré Vendas - Nova Proposta</h5>
      </Row>
      <Row>
        <Card.Body className={"card-dashboard shadow bg-white rounded m-2 col-12 "+(getTamanho(474)?'p-0':'p-5')}>
          <Tabs defaultActiveKey="form" id="newQuote">
            <Tab eventKey="form" title="Formulário">
              <div className="p-3">
                <HubspotForm
                  portalId='4478780'
                  formId='e1c9d8e2-08f8-40da-bf48-8bdc6d35f7db'
                  onSubmit={() => console.log('Submit!')}
                  onReady={(form) => console.log('Form ready!')}
                  loading={<div>Carregando...</div>}
                />
              </div>
            </Tab>
            <Tab eventKey="goto" title="GoTo">
              <iframe style={{ width: "100%", height: "70vh" }} src="https://embedded.scansource.com.br/configuradores/siptrunk/logmein/iframe" frameborder="0"></iframe>
              {/* <Iframe width="100%" height="600px" url="https://www.scansource.com.br/embed/configuradores/masteragent/logmein" className="iframe-configurator" /> */}
            </Tab>
            {/*<Tab eventKey="net2phone" title="Net2Phone">
              <iframe style={{ width: "100%", height: "70vh" }} src="https://www.scansource.com.br/embed/configuradores/masteragent/net2phone" frameborder="0"></iframe>
            </Tab>*/}
            <Tab eventKey="cyberpass" title="Cyberpass">
              <iframe style={{ width: "100%", height: "70vh" }} src="https://embedded.scansource.com.br/configuradores/cyberpass/iframe" frameborder="0"></iframe>
              {/* <Iframe  style={{ width: "100%", height: "70vh" }} url="https://www.scansource.com.br/embed/configuradores/masteragent/cyberpass" className="iframe-configurator" />   */}
            </Tab>
          </Tabs>
        </Card.Body>
      </Row>
    </Container>
  );
}
